// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__1KLEs","hideOnTablet":"styles_hideOnTablet__J9t9Z","hideOnMobile":"styles_hideOnMobile__3QGJI"};